import { render, staticRenderFns } from "./EditorImage.vue?vue&type=template&id=2cde1573&scoped=true&"
import script from "./EditorImage.vue?vue&type=script&lang=ts&"
export * from "./EditorImage.vue?vue&type=script&lang=ts&"
import style0 from "./EditorImage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EditorImage.vue?vue&type=style&index=1&id=2cde1573&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cde1573",
  null
  
)

export default component.exports